import React from 'react';
import Header from '../components/Header';
import ContentSection from '../components/ContentSection';
import Footer from '../components/Footer';
import '../styles/App.css';

function Privacy() {
  const privacyIntro = {
    sectionTitle: (
      <>
        Privacy <span style={{ color: 'red' }}>Policy</span>
      </>
    ),
    sectionDescription: 'Last Updated: December 30, 2025',
    items: [
      {
        title: '',
        body1: (
          <>
            <p>Begin Strength and Begin the Work, LLC ("Company," "we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services ("Services").</p>
          </>
        ),
      },
    ],
  };

  const privacyContent = {
    sectionTitle: '',
    sectionDescription: '',
    items: [
      {
        title: '1. Information We Collect',
        body1: (
          <>
            <p className="content-subtitle">1.1 Information You Provide to Us</p>
            <p>We may collect information you voluntarily provide, including:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px', marginBottom: '16px' }}>
              <li>Name</li>
              <li>Email address</li>
              <li>Account login credentials</li>
              <li>Payment-related information (processed by third-party providers)</li>
              <li>Fitness-related inputs you choose to submit (e.g., goals, preferences, training data)</li>
              <li>Communications with us (support requests, emails)</li>
            </ul>
            <p>We do not collect medical records or provide medical advice.</p>

            <p className="content-subtitle">1.2 Information Collected Automatically</p>
            <p>When you use the Services, we may automatically collect certain information, including:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px', marginBottom: '16px' }}>
              <li>Device type, operating system, and browser</li>
              <li>IP address</li>
              <li>Usage data (pages viewed, features used, timestamps)</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
            <p>This information helps us improve performance, security, and user experience.</p>
          </>
        ),
      },
      {
        title: '2. How We Use Your Information',
        body1: (
          <>
            <p>We use information collected to:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
              <li>Provide, operate, and maintain the Services</li>
              <li>Create and manage user accounts</li>
              <li>Process payments and subscriptions</li>
              <li>Communicate with you (service-related notices, updates, support)</li>
              <li>Improve and personalize the Services</li>
              <li>Detect, prevent, and address technical or security issues</li>
              <li>Comply with legal obligations</li>
            </ul>
          </>
        ),
      },
      {
        title: '3. Payments & Financial Information',
        body1: (
          <>
            <p>Payments are processed by third-party payment processors (such as Stripe, Apple, or Google). We do not store full payment card details on our servers.</p>
            <p>Your payment information is handled according to the payment processor's privacy policy and terms.</p>
          </>
        ),
      },
      {
        title: '4. Sharing of Information',
        body1: (
          <>
            <p><strong>We do not sell your personal information.</strong></p>
            <p>We may share information with:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px', marginBottom: '16px' }}>
              <li>Service providers who perform services on our behalf (hosting, analytics, payments)</li>
              <li>Payment processors to complete transactions</li>
              <li>Legal authorities if required to comply with applicable laws, regulations, or legal processes</li>
              <li>Business transfers in connection with a merger, acquisition, or sale of assets</li>
            </ul>
            <p>All third parties are required to protect your information consistent with this Policy.</p>
          </>
        ),
      },
      {
        title: '5. Cookies & Tracking Technologies',
        body1: (
          <>
            <p>We may use cookies or similar technologies to:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px', marginBottom: '16px' }}>
              <li>Maintain user sessions</li>
              <li>Analyze usage patterns</li>
              <li>Improve functionality and performance</li>
            </ul>
            <p>You can control cookie preferences through your browser settings. Disabling cookies may limit certain features of the Services.</p>
          </>
        ),
      },
      {
        title: '6. Data Retention',
        body1: (
          <>
            <p>We retain personal information only for as long as reasonably necessary to:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
              <li>Provide the Services</li>
              <li>Comply with legal obligations</li>
              <li>Resolve disputes</li>
              <li>Enforce agreements</li>
            </ul>
          </>
        ),
      },
      {
        title: '7. Data Security',
        body1: (
          <>
            <p>We implement reasonable administrative, technical, and physical safeguards to protect your information. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
          </>
        ),
      },
      {
        title: '8. Your Choices & Rights',
        body1: (
          <>
            <p>You may:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px', marginBottom: '16px' }}>
              <li>Access or update your account information</li>
              <li>Request deletion of your account (subject to legal and contractual obligations)</li>
              <li>Opt out of non-essential communications</li>
            </ul>
            <p>Requests can be made by contacting us at the email address below.</p>
          </>
        ),
      },
      {
        title: "9. Children's Privacy",
        body1: (
          <>
            <p>The Services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children under 18. If we learn that such information has been collected, we will delete it.</p>
          </>
        ),
      },
      {
        title: '10. Third-Party Links',
        body1: (
          <>
            <p>The Services may contain links to third-party websites or services. We are not responsible for the privacy practices of those third parties. We encourage you to review their privacy policies separately.</p>
          </>
        ),
      },
      {
        title: '11. Changes to This Privacy Policy',
        body1: (
          <>
            <p>We may update this Privacy Policy from time to time. Changes will be effective when posted. Your continued use of the Services after updates constitutes acceptance of the revised Policy.</p>
          </>
        ),
      },
      {
        title: '12. Contact Us',
        body1: (
          <>
            <p>If you have questions or concerns about this Privacy Policy or our data practices, contact us at:</p>
            <p style={{ marginTop: '16px' }}>
              <strong>Email:</strong> sam@beginthework.com<br />
              <strong>Company:</strong> Begin the Work, LLC<br />
              <strong>Location:</strong> Oklahoma, United States
            </p>
          </>
        ),
      },
    ],
  };

  return (
    <div className="home">
      <Header />
      <main>
        <ContentSection
          sectionTitle={privacyIntro.sectionTitle}
          sectionDescription={privacyIntro.sectionDescription}
          items={privacyIntro.items}
          sectionClass="privacy-section"
          spacer={true}
        />

        <ContentSection
          sectionTitle={privacyContent.sectionTitle}
          sectionDescription={privacyContent.sectionDescription}
          items={privacyContent.items}
          sectionClass="privacy-content-section"
        />

        <Footer />
      </main>
    </div>
  );
}

export default Privacy;
